module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lYfBy"))).then(() => module.bundle.root('ikE14'));